/** reports: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "nameDaily": "{base} (daily)",
  "nameWeekly": "{base} (weekly)",
  "nameMonthly": "{base} (monthly)",
  "daily": "Daily",
  "weekly": "Weekly",
  "monthly": "Monthly",
  "everyN_day": "Every {n} days",
  "everyN_week": "Every {n} weeks",
  "everyN_month": "Every {n} months",
  "onDays": "on {days}",
  "dayN": "day {n}",
  "atTime": "at {time}",
  "nPlayers": "{n} player | {n} players",
  "nGroups": "{n} group | {n} groups",
  "tagsMatch_any": "tags any of {tags}",
  "tagsMatch_all": "tags all of {tags}",
  "nContent": "{n} content item | {n} content items",
  "emailN": "email {n}",
  "notEmail": "“{v}” is not an email address.",
  "editReport": "Edit report · {name}",
  "day": "day | days",
  "week": "week | weeks",
  "month": "month | months",
  "covers": "Each report covers",
  "nextRuns": "Next: {runs}",
  "tzNote": "Dates and times are in {tz}.",
  "removeX": "Remove {v}",
  "rows": "{n} row | {n} rows",
  "cat_Playback": "Playback",
  "cat_Health Check": "Health Check",
  "cat_Players": "Players",
  "cat_Content": "Content",
  "cat_Audit": "Audit",
  "type_playback_summary": "Playback summary",
  "desc_playback_summary": "Plays and time on screen per content item.",
  "type_playback_by_day": "Playback by day",
  "desc_playback_by_day": "Plays and time on screen per content item, day by day.",
  "type_playback_by_player": "Playback by player",
  "desc_playback_by_player": "What each player played, and for how long.",
  "type_playback_daily_by_player": "Daily playback by player",
  "desc_playback_daily_by_player": "What each player played, day by day.",
  "type_playback_individual": "Individual playbacks",
  "desc_playback_individual": "Every single play with its time, player and duration. Can be very large: use CSV or Excel.",
  "type_health_issues": "Health Check issues",
  "desc_health_issues": "Open issues at the time the report runs, plus those resolved in the period.",
  "type_players": "Players",
  "desc_players": "Every player with its status, device, app version, location, groups and tags.",
  "type_published_content": "Published content",
  "desc_published_content": "What is published where: every player and group list with its restrictions.",
  "type_audit_log": "Audit log",
  "desc_audit_log": "What people did in the period (admins only).",
  "preset_yesterday": "Yesterday",
  "preset_last7": "Last 7 days",
  "preset_last30": "Last 30 days",
  "preset_thisMonth": "This month",
  "preset_lastMonth": "Last month",
  "covers_day": "the previous day",
  "covers_week": "the previous 7 days",
  "covers_month": "the previous calendar month",
  "errDates": "Choose a start date on or before the end date.",
  "errDay": "Choose at least one day.",
  "errTime": "Choose the time of day.",
  "errEnd": "The end date is before the start date.",
  "errNoRun": "This schedule has no future run: check its end date.",
  "errPlayer": "Choose at least one player, or All players.",
  "errGroup": "Choose at least one player group, or All players.",
  "errCheck": "Check the report settings.",
  "onceNow": "Once, now",
  "allPlayers": "All players",
  "allContent": "all content",
  "fPdf": "To read or print. Up to 5,000 rows.",
  "fXlsx": "To sort and filter in Excel. Up to 1,000,000 rows.",
  "fCsv": "For other tools. Up to 1,000,000 rows.",
  "fHtml": "Opens in any browser. Up to 5,000 rows.",
  "newReport": "New report",
  "steps": "Steps",
  "category": "Category",
  "reportType": "Report type",
  "snapshot": "Snapshot",
  "howOften": "How often",
  "oneTime": "One time",
  "recurring": "Recurring",
  "snapshotHint": "This report is a snapshot: it shows the state at the moment it runs. It runs as soon as you create it.",
  "period": "Period",
  "custom": "Custom",
  "from": "From",
  "to": "To",
  "every": "Every",
  "interval": "Interval",
  "unit": "Unit",
  "at": "at",
  "timeOfDay": "Time of day",
  "days": "Days",
  "on": "On",
  "lastDay": "the last day",
  "lastDayHint": "(days 29–31 don't exist in every month: use \"the last day\")",
  "starts": "Starts",
  "ends": "Ends",
  "neverEnds": "Never ends",
  "eachSnapshot": "Each run is a snapshot at that moment.",
  "players": "Players",
  "choosePlayers": "Choose players",
  "chooseGroups": "Choose groups",
  "noGroups": "No player groups yet.",
  "onlyPlayersWith": "Only players with",
  "playerTagMatch": "Player tag match",
  "anyOf": "any of",
  "allOf": "all of",
  "theseTagsEmpty": "these tags (empty = no tag filter):",
  "content": "Content",
  "noneAll": "(none chosen = all content)",
  "onlyContentWith": "Only content with",
  "contentTagMatch": "Content tag match",
  "theseTags": "these tags:",
  "wholeOrg": "This report covers the whole organization; there is nothing to narrow down.",
  "name": "Name",
  "format": "Format",
  "emailIt": "Email it to",
  "optional": "(optional)",
  "keptHint": "Every run is also kept here for 90 days to download. Email needs a mail server set up on the Displaro server.",
  "loadingPreview": "Loading preview…",
  "previewRows": "Preview the first rows",
  "snapshotNow": "Snapshot now",
  "noData": "No data for this period and these filters.",
  "back": "Back",
  "cancel": "Cancel",
  "next": "Next",
  "saving": "Saving…",
  "saveChanges": "Save changes",
  "createRun": "Create and run",
  "createSchedule": "Create schedule",
  "lastDayShort": "last day",
  "runRows": "{rows} rows · {size}",
  "rowLimit": " · row limit reached",
  "deleteQ": "Delete the report “{name}”? Its files are deleted too.",
  "deleteRecQ": "Delete the report “{name}” and its schedule? Its files are deleted too.",
  "byPerson": "by {name}",
  "emailedTo": "Emailed to {list}",
  "nextAt": "Next: {when}",
  "historyOf": "History · {name}",
  "stQueued": "Queued",
  "stRunning": "Generating…",
  "stDone": "Ready",
  "stFailed": "Failed",
  "title": "Reports",
  "intro": "One-time and scheduled reports on playback, health, players and publishing. Files are kept for 90 days.",
  "newReportBtn": "New Report",
  "show": "Show",
  "all": "All",
  "oneTimeShort": "One-time",
  "search": "Search",
  "searchReports": "Search reports",
  "colReport": "Report",
  "colWhen": "When",
  "colLatest": "Latest run",
  "actions": "Actions",
  "downloadOnly": "Download only",
  "scheduleEnded": "Schedule ended",
  "notRun": "Not run yet",
  "downloadBtn": "⬇ Download",
  "runNow": "Run now",
  "edit": "Edit",
  "history": "History",
  "delete": "Delete",
  "loading": "Loading…",
  "noMatch": "No reports match.",
  "noReports": "No reports yet",
  "emptyHint": "Get playback, health and player reports as PDF, Excel, CSV or HTML — once, or on a schedule.",
  "last50": "The last 50 runs. Files are kept for 90 days.",
  "download": "Download",
  "expired": "Expired",
  "noRuns": "No runs yet.",
  "failed": "Failed",
  "savedX": "Report “{name}” saved",
  "generatingX": "Generating “{name}”…",
  "scheduledX": "Scheduled “{name}”",
  "deletedX": "Deleted “{name}”",
  "emailSent": "✉️ Sent",
  "emailSkipped": "✉️ Skipped",
  "emailFailed": "✉️ Failed"
};
const ar: typeof en = {
  "nameDaily": "{base} (يومي)",
  "nameWeekly": "{base} (أسبوعي)",
  "nameMonthly": "{base} (شهري)",
  "daily": "يوميًا",
  "weekly": "أسبوعيًا",
  "monthly": "شهريًا",
  "everyN_day": "كل {n} أيام",
  "everyN_week": "كل {n} أسابيع",
  "everyN_month": "كل {n} أشهر",
  "onDays": "في {days}",
  "dayN": "اليوم {n}",
  "atTime": "في {time}",
  "nPlayers": "لا مشغلات | مشغل واحد | مشغلان | {n} مشغلات | {n} مشغلًا | {n} مشغل",
  "nGroups": "لا مجموعات | مجموعة واحدة | مجموعتان | {n} مجموعات | {n} مجموعة | {n} مجموعة",
  "tagsMatch_any": "الوسوم أيٌّ من {tags}",
  "tagsMatch_all": "الوسوم كل {tags}",
  "nContent": "لا عناصر | عنصر محتوى واحد | عنصرا محتوى | {n} عناصر محتوى | {n} عنصر محتوى | {n} عنصر محتوى",
  "emailN": "بريد {n}",
  "notEmail": "«{v}» ليس عنوان بريد إلكتروني.",
  "editReport": "تعديل التقرير · {name}",
  "day": "يوم | أيام",
  "week": "أسبوع | أسابيع",
  "month": "شهر | أشهر",
  "covers": "يغطي كل تقرير",
  "nextRuns": "التالي: {runs}",
  "tzNote": "التواريخ والأوقات بتوقيت {tz}.",
  "removeX": "إزالة {v}",
  "rows": "لا صفوف | صف واحد | صفان | {n} صفوف | {n} صفًا | {n} صف",
  "cat_Playback": "التشغيل",
  "cat_Health Check": "فحص الحالة",
  "cat_Players": "المشغلات",
  "cat_Content": "المحتوى",
  "cat_Audit": "التدقيق",
  "type_playback_summary": "ملخص التشغيل",
  "desc_playback_summary": "مرات التشغيل ومدة الظهور على الشاشة لكل عنصر محتوى.",
  "type_playback_by_day": "التشغيل حسب اليوم",
  "desc_playback_by_day": "مرات التشغيل ومدة الظهور لكل عنصر محتوى، يومًا بيوم.",
  "type_playback_by_player": "التشغيل حسب المشغل",
  "desc_playback_by_player": "ما عرضه كل مشغل، ولأي مدة.",
  "type_playback_daily_by_player": "التشغيل اليومي حسب المشغل",
  "desc_playback_daily_by_player": "ما عرضه كل مشغل، يومًا بيوم.",
  "type_playback_individual": "مرات التشغيل الفردية",
  "desc_playback_individual": "كل تشغيل بوقته ومشغله ومدته. قد يكون كبيرًا جدًا: استخدم CSV أو Excel.",
  "type_health_issues": "مشكلات فحص الحالة",
  "desc_health_issues": "المشكلات المفتوحة وقت تشغيل التقرير، والمشكلات التي حُلّت خلال الفترة.",
  "type_players": "المشغلات",
  "desc_players": "كل مشغل مع حالته وجهازه وإصدار التطبيق وموقعه ومجموعاته ووسومه.",
  "type_published_content": "المحتوى المنشور",
  "desc_published_content": "ما المنشور وأين: قائمة كل مشغل ومجموعة مع قيودها.",
  "type_audit_log": "سجل التدقيق",
  "desc_audit_log": "ما فعله الأشخاص خلال الفترة (للمسؤولين فقط).",
  "preset_yesterday": "أمس",
  "preset_last7": "آخر ٧ أيام",
  "preset_last30": "آخر ٣٠ يومًا",
  "preset_thisMonth": "هذا الشهر",
  "preset_lastMonth": "الشهر الماضي",
  "covers_day": "اليوم السابق",
  "covers_week": "الأيام السبعة السابقة",
  "covers_month": "الشهر التقويمي السابق",
  "errDates": "اختر تاريخ بداية في تاريخ النهاية أو قبله.",
  "errDay": "اختر يومًا واحدًا على الأقل.",
  "errTime": "اختر وقت اليوم.",
  "errEnd": "تاريخ النهاية قبل تاريخ البداية.",
  "errNoRun": "لا يوجد تشغيل مستقبلي لهذا الجدول: تحقق من تاريخ نهايته.",
  "errPlayer": "اختر مشغلًا واحدًا على الأقل، أو كل المشغلات.",
  "errGroup": "اختر مجموعة مشغلات واحدة على الأقل، أو كل المشغلات.",
  "errCheck": "تحقق من إعدادات التقرير.",
  "onceNow": "مرة واحدة، الآن",
  "allPlayers": "كل المشغلات",
  "allContent": "كل المحتوى",
  "fPdf": "للقراءة أو الطباعة. حتى ٥٬٠٠٠ صف.",
  "fXlsx": "للفرز والتصفية في Excel. حتى ١٬٠٠٠٬٠٠٠ صف.",
  "fCsv": "لأدوات أخرى. حتى ١٬٠٠٠٬٠٠٠ صف.",
  "fHtml": "يُفتح في أي متصفح. حتى ٥٬٠٠٠ صف.",
  "newReport": "تقرير جديد",
  "steps": "الخطوات",
  "category": "الفئة",
  "reportType": "نوع التقرير",
  "snapshot": "لقطة",
  "howOften": "عدد المرات",
  "oneTime": "مرة واحدة",
  "recurring": "متكرر",
  "snapshotHint": "هذا التقرير لقطة: يعرض الحالة لحظة تشغيله. ويُشغَّل فور إنشائه.",
  "period": "الفترة",
  "custom": "مخصص",
  "from": "من",
  "to": "إلى",
  "every": "كل",
  "interval": "الفاصل",
  "unit": "الوحدة",
  "at": "في",
  "timeOfDay": "وقت اليوم",
  "days": "الأيام",
  "on": "في",
  "lastDay": "اليوم الأخير",
  "lastDayHint": "(الأيام ٢٩–٣١ لا توجد في كل شهر: استخدم «اليوم الأخير»)",
  "starts": "يبدأ",
  "ends": "ينتهي",
  "neverEnds": "بلا نهاية",
  "eachSnapshot": "كل تشغيل لقطة في تلك اللحظة.",
  "players": "المشغلات",
  "choosePlayers": "اختيار مشغلات",
  "chooseGroups": "اختيار مجموعات",
  "noGroups": "لا توجد مجموعات مشغلات بعد.",
  "onlyPlayersWith": "فقط المشغلات التي لها",
  "playerTagMatch": "مطابقة وسوم المشغل",
  "anyOf": "أيٌّ من",
  "allOf": "كل",
  "theseTagsEmpty": "هذه الوسوم (فارغ = بلا تصفية):",
  "content": "المحتوى",
  "noneAll": "(عدم الاختيار = كل المحتوى)",
  "onlyContentWith": "فقط المحتوى الذي له",
  "contentTagMatch": "مطابقة وسوم المحتوى",
  "theseTags": "هذه الوسوم:",
  "wholeOrg": "يغطي هذا التقرير المؤسسة كلها؛ لا يوجد ما يمكن تضييقه.",
  "name": "الاسم",
  "format": "الصيغة",
  "emailIt": "إرساله بالبريد إلى",
  "optional": "(اختياري)",
  "keptHint": "يُحفظ كل تشغيل هنا أيضًا لمدة ٩٠ يومًا للتنزيل. يحتاج البريد إلى خادم بريد مُعدّ على خادم Displaro.",
  "loadingPreview": "جارٍ تحميل المعاينة…",
  "previewRows": "معاينة الصفوف الأولى",
  "snapshotNow": "لقطة الآن",
  "noData": "لا توجد بيانات لهذه الفترة وهذه المرشحات.",
  "back": "رجوع",
  "cancel": "إلغاء",
  "next": "التالي",
  "saving": "جارٍ الحفظ…",
  "saveChanges": "حفظ التغييرات",
  "createRun": "إنشاء وتشغيل",
  "createSchedule": "إنشاء جدول",
  "lastDayShort": "اليوم الأخير",
  "runRows": "{rows} صفوف · {size}",
  "rowLimit": " · تم بلوغ حد الصفوف",
  "deleteQ": "حذف التقرير «{name}»؟ تُحذف ملفاته أيضًا.",
  "deleteRecQ": "حذف التقرير «{name}» وجدوله؟ تُحذف ملفاته أيضًا.",
  "byPerson": "بواسطة {name}",
  "emailedTo": "أُرسل بالبريد إلى {list}",
  "nextAt": "التالي: {when}",
  "historyOf": "السجل · {name}",
  "stQueued": "في الانتظار",
  "stRunning": "جارٍ الإنشاء…",
  "stDone": "جاهز",
  "stFailed": "فشل",
  "title": "التقارير",
  "intro": "تقارير لمرة واحدة ومجدولة عن التشغيل والحالة والمشغلات والنشر. تُحفظ الملفات لمدة ٩٠ يومًا.",
  "newReportBtn": "تقرير جديد",
  "show": "عرض",
  "all": "الكل",
  "oneTimeShort": "لمرة واحدة",
  "search": "بحث",
  "searchReports": "البحث في التقارير",
  "colReport": "التقرير",
  "colWhen": "متى",
  "colLatest": "آخر تشغيل",
  "actions": "الإجراءات",
  "downloadOnly": "تنزيل فقط",
  "scheduleEnded": "انتهى الجدول",
  "notRun": "لم يُشغَّل بعد",
  "downloadBtn": "⬇ تنزيل",
  "runNow": "تشغيل الآن",
  "edit": "تعديل",
  "history": "السجل",
  "delete": "حذف",
  "loading": "جارٍ التحميل…",
  "noMatch": "لا توجد تقارير مطابقة.",
  "noReports": "لا توجد تقارير بعد",
  "emptyHint": "احصل على تقارير التشغيل والحالة والمشغلات بصيغة PDF أو Excel أو CSV أو HTML — مرة واحدة أو وفق جدول.",
  "last50": "آخر ٥٠ تشغيلًا. تُحفظ الملفات لمدة ٩٠ يومًا.",
  "download": "تنزيل",
  "expired": "منتهي",
  "noRuns": "لا توجد عمليات تشغيل بعد.",
  "failed": "فشل",
  "savedX": "تم حفظ التقرير «{name}»",
  "generatingX": "جارٍ إنشاء «{name}»…",
  "scheduledX": "تمت جدولة «{name}»",
  "deletedX": "تم حذف «{name}»",
  "emailSent": "✉️ أُرسل",
  "emailSkipped": "✉️ تم التخطي",
  "emailFailed": "✉️ فشل"
};
export default { en, ar };
